export default __webpack_public_path__ + "static/media/cargomap.b87b3a16.svg";